export default "__VITE_ASSET__DyqM7zv5__"